export const SET_ORDER = 'SET_ORDER';

export const FETCH_ORDER = 'FETCH_ORDER';
